import { memo, useEffect, useState } from 'react'
import styled from 'styled-components'
import { useUnit } from 'effector-react'
import { useLocation} from 'react-router-dom'

import { MAIN_COLORS } from '../../UI/consts/colors'
import qr from './UI/icons/qr.svg'
import info from './UI/icons/info.svg'
import avatar from '../../UI/icons/Avatar.svg'
import Logo from './UI/icons/Logo.png'

import { namedRoutes } from '../../UI/consts/routs'
import { getProfilePhoto } from '../../components/getProfilePhoto'
import { $userInfoBd } from '../../components/store/user'
import { $scanQrFn } from '../../components/store/scanQrFn'

import Modal from '../../UI/components/UIKit/Modal'
import Skeleton from '../../UI/components/UIKit/Skeleton'

const Head = styled.div<{saveArea:any, miniHeader: boolean}>`
    position: absolute;
    width: 100%;
    z-index: 100;    
    top: ${p => p.saveArea}px;
    left: 0;
`
const Column = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
    width: 100%;

    h4{
      color: ${MAIN_COLORS.pink};
    }
    h3 {
      color: #ffffff;
      overflow: hidden;
      text-overflow: ellipsis;
      max-width: 8rem;
    }
`

const Flex = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 12px;
`;
const Column2 = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 8px;
`
const Wrapper = styled.div<{miniHeader: boolean}>`
    display: flex;
    justify-content: ${p => p.miniHeader ? 'center' : 'flex-start'};
    gap: 6px;
    align-items: center;
    padding: 0 15px;
    height: ${p => !p.miniHeader ? 112 : 48}px;

    img {
      width: ${p => p.miniHeader ? '24px' : '40px'};
      height: ${p => p.miniHeader ? '24px' : '40px'};
      cursor: pointer;
    }

    .avatar{
      height: 48px;
      width: 48px;
      border-radius: 50%;
      object-fit: contain;
      cursor: unset;
    }

    .logo {
      width: 100%;
      height: 64px;
    }
`

const Header = () => {
  const user = useUnit($userInfoBd);
  const scanFn = useUnit($scanQrFn);
  const { pathname } = useLocation();

  const [ miniHeader, setMiniHeader ] = useState(false);
  const [ modalIsOpen, setModalIsOpen ] = useState(false);

  const [ imgIsLoading, setImgIsLoading ] = useState(true);
  const [ image, setImage ] = useState<any>({});
  const qrText ='Отсканируйте Qr';
    
  useEffect(() => {
      const userId = window.Telegram.WebApp.initDataUnsafe.user?.id
      getProfilePhoto(userId).then((res)=>{
        setImage(res);
        setImgIsLoading(false);
      })
  }, [])

  useEffect(() => {
    if (pathname.length === 1) {
      window.Telegram.WebApp.BackButton.hide();
      return setMiniHeader(false);
    }
    window.Telegram.WebApp.BackButton.show();
    setMiniHeader(true);
  },[pathname])

  const scanQrHandler = () => {
    if (scanFn) {
      window.Telegram.WebApp.showScanQrPopup({text: qrText}, (text: string) => {
        const type = text.includes('achv')
        scanFn({type: type ? 'ach' : 'toy', value: text}, 'notInitial')
      });
    }
  }

  return (
    <>
    <Head saveArea={window.Telegram.WebApp.safeAreaInset.top + window.Telegram.WebApp.contentSafeAreaInset.top} miniHeader={miniHeader}>
        <Wrapper miniHeader={miniHeader}>
          {!miniHeader ?
            <Column>
              <img className='logo' src={Logo} alt='' onClick={()=>window.Telegram.WebApp.openTelegramLink('https://t.me/loot_ball ','_blank')}/>
              <Flex>
                {imgIsLoading ? <Skeleton height={'48px'} width={'84px'} radius={'50%'}/> : <img className='avatar' src={image ? image : avatar} alt=''/>}
                <Column>
                  <h4>Привет!</h4>
                  <h3>{user?.name}</h3>
                </Column>
              </Flex>
            </Column>
          : null
            //<div style={{width:'30px'}}/><img src={back} alt='' onClick={() => navigate(-1)}/> 
          }
          <h1>{namedRoutes[pathname]?.title}</h1>
          {process.env.REACT_APP_SHOW_QR_SCANNER === 'true' && !miniHeader && (
            <img alt='' src={qr} onClick={scanQrHandler} />
          )}
          {miniHeader && namedRoutes[pathname] &&
            <img
              alt=''
              src={info}
              onClick={() => setModalIsOpen(true)}
            />
          }
        </Wrapper>
    </Head>
    <Modal position='top' isOpen={modalIsOpen} close={() => setModalIsOpen(false)}>
      <Column2>
        <h1 style={{
          background:`${MAIN_COLORS.gradient_yellow_pink}`,
          WebkitBackgroundClip: 'text',
          WebkitTextFillColor: 'transparent',
          backgroundClip: 'text'
        }}>Информация</h1>
        <h4>{namedRoutes[pathname]?.info}</h4>
      </Column2>
    </Modal>
    </>
  )
}

export default memo(Header)